import React, { useState, useEffect, useRef } from 'react';
import { ar } from './translations';

const PHONE = '966501472531';
const EMAIL = 'malshowyah@gmail.com';


function fireConversion() {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { 'send_to': 'AW-18068820526/d9_KCLiv6dYcEK6k8adD' });
  }
}

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add('visible'); obs.disconnect(); }
    }, { threshold: 0.1 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

function Reveal({ children, style, delay = 0 }) {
  const ref = useReveal();
  return <div ref={ref} className="reveal" style={{ transitionDelay: `${delay}ms`, ...style }}>{children}</div>;
}

function WaIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}


function AvailabilityTracker() {
  const total = 15;
  const taken = 7;
  const remaining = total - taken;
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1rem', background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: '100px', padding: '10px 20px', marginBottom: '1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        {Array.from({ length: total }).map((_, i) => (
          <span key={i} style={{ width: '10px', height: '10px', borderRadius: '50%', background: i < taken ? '#D97706' : '#E5E7EB', flexShrink: 0, transition: 'background .3s' }} />
        ))}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#D97706', animation: 'ping 1.5s cubic-bezier(0,0,0.2,1) infinite', flexShrink: 0 }} />
        <span style={{ fontSize: '12.5px', fontWeight: 600, color: '#92400E' }}>{remaining} spots remaining</span>
        <span style={{ fontSize: '12px', color: '#B45309' }}>this cycle</span>
      </div>
    </div>
  );
}

function CheckIcon({ dim }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" style={{ flexShrink: 0, marginTop: '2px' }}>
      <circle cx="8" cy="8" r="8" fill={dim ? '#F0EFE8' : 'var(--primary-light)'} />
      <path d="M4.5 8L7 10.5L11.5 5.5" stroke={dim ? '#C8C4BE' : 'var(--primary)'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

function LogoMark({ size = 32 }) {
  const s = size;
  return (
    <svg width={s} height={Math.round(s * 1.1)} viewBox="0 0 56 62" fill="none" aria-hidden="true">
      <path d="M28 2 L54 18 L54 44 L28 60 L2 44 L2 18 Z" fill="none" stroke="white" strokeWidth="1.8" strokeLinejoin="round" opacity="0.3"/>
      <path d="M28 10 L46 20 L46 42 L28 52 L10 42 L10 20 Z" fill="none" stroke="white" strokeWidth="1.4" strokeLinejoin="round" opacity="0.6"/>
      <path d="M28 18 L38 24 L38 38 L28 44 L18 38 L18 24 Z" fill="white" strokeLinejoin="round" opacity="0.9"/>
    </svg>
  );
}

function PackageCard({ t, hero = false }) {
  return (
    <div style={{ borderRadius: '20px', border: '1px solid var(--primary)', background: 'var(--card)', padding: '2rem', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(45,106,79,0.1)' }}>
      <span style={{ display: 'inline-block', fontSize: '11px', fontWeight: 500, padding: '4px 12px', borderRadius: '100px', background: 'var(--primary-light)', color: 'var(--primary)', marginBottom: '1rem', width: 'fit-content' }}>{t.pkg1Available}</span>
      <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.25rem', fontWeight: 400, color: 'var(--text)', marginBottom: '.3rem' }}>{t.pkg1Name}</h3>
      <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '1.25rem', lineHeight: 1.7 }}>{t.pkg1Desc}</p>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '5px', marginBottom: '.25rem' }}>
        <span style={{ fontFamily: 'var(--serif)', fontSize: hero ? '2.5rem' : '2.8rem', fontWeight: 300, color: 'var(--text)', lineHeight: 1 }}>{t.pkg1Price}</span>
        <span style={{ fontSize: '1rem', color: 'var(--text-muted)' }}>{t.pkg1Currency}</span>
      </div>
      <p style={{ fontSize: '11px', color: 'var(--text-muted)', marginBottom: '1.25rem' }}>{t.pkg1Sub}</p>
      <hr style={{ border: 'none', borderTop: '1px solid var(--border)', marginBottom: '1.1rem' }} />
      <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '1rem' }}>
        {t.pkg1Feats.map((f, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '9px', fontSize: '13px', color: 'var(--text)', lineHeight: 1.5 }}>
            <CheckIcon />{f}
          </li>
        ))}
      </ul>
      <div style={{ borderRadius: '10px', border: '1px solid rgba(45,106,79,0.25)', background: 'var(--primary-light)', padding: '1rem', marginBottom: '1.25rem' }}>
        <p style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--primary)', marginBottom: '.9rem' }}>{t.pkg1BonusLabel}</p>

        <p style={{ fontSize: '11px', fontWeight: 600, color: 'var(--primary)', marginBottom: '.5rem', opacity: 0.8 }}>Full Tax Setup</p>
        <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '7px', marginBottom: '1rem' }}>
          {t.pkg1Bonus.slice(0, 2).map((f, i) => (
            <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12px', color: 'var(--primary)', lineHeight: 1.5 }}>
              <svg width="13" height="13" viewBox="0 0 14 14" aria-hidden="true" style={{ flexShrink: 0, marginTop: '2px' }}><circle cx="7" cy="7" r="7" fill="var(--primary)" /><path d="M3.5 7L6 9.5L10.5 5" stroke="white" strokeWidth="1.4" strokeLinecap="round" fill="none" /></svg>
              {f}
            </li>
          ))}
        </ul>

        <div style={{ borderTop: '1px solid rgba(45,106,79,0.2)', paddingTop: '.9rem' }}>
          <p style={{ fontSize: '11px', fontWeight: 600, color: 'var(--primary)', marginBottom: '.5rem', opacity: 0.8 }}>12 Hour Support Response</p>
          <div style={{ display: 'flex', gap: '.5rem', flexWrap: 'wrap' }}>
            {['📞 Phone', '💬 WhatsApp', '📧 Email', '🎥 Zoom'].map((item, i) => (
              <span key={i} style={{ fontSize: '11px', color: 'var(--primary)', background: 'rgba(45,106,79,0.1)', borderRadius: '100px', padding: '3px 10px', fontWeight: 500 }}>{item}</span>
            ))}
          </div>
        </div>
      </div>
      <button onClick={() => { fireConversion(); window.open('https://wa.me/' + PHONE + '?text=' + encodeURIComponent('Send your free business launch roadmap'), '_blank'); }} style={{ width: '100%', padding: '13px', borderRadius: '100px', fontSize: '13px', fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', background: 'var(--primary)', color: '#fff', border: 'none', transition: 'opacity .2s' }}
        onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
        onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
        <WaIcon size={15} />Get your free business roadmap
      </button>
    </div>
  );
}


function WaitlistButton({ label }) {
  const [count, setCount] = React.useState(3);
  const [joined, setJoined] = React.useState(false);
  const [showNotif, setShowNotif] = React.useState(false);

  const handleClick = () => {
    if (!joined) {
      const newCount = count + 1;
      setCount(newCount);
      setJoined(true);
      setShowNotif(true);
      fireConversion();
      window.open('https://wa.me/' + PHONE + '?text=' + encodeURIComponent('I would like to join the waitlist. I am number ' + newCount + ' on the list.'), '_blank');
      setTimeout(() => setShowNotif(false), 4000);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {showNotif && (
        <div style={{ background: 'var(--primary-light)', border: '1px solid var(--primary-border)', borderRadius: '10px', padding: '10px 14px', fontSize: '12.5px', color: 'var(--primary)', fontWeight: 500, textAlign: 'center' }}>
          You have joined the waitlist as number {count}
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: 'var(--text-muted)' }}>
        <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#F59E0B', flexShrink: 0 }} />
        <span><strong style={{ color: 'var(--text)' }}>{count}</strong> people on the waitlist</span>
      </div>
      <button
        onClick={handleClick}
        style={{ width: '100%', padding: '14px', borderRadius: '100px', fontSize: '13.5px', fontWeight: 500, cursor: joined ? 'default' : 'pointer', fontFamily: 'var(--sans)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', border: '1px solid var(--border)', color: joined ? 'var(--primary)' : 'var(--text)', background: joined ? 'var(--primary-light)' : 'var(--card)', transition: 'all .2s' }}>
        {joined ? 'You are on the waitlist' : label}
      </button>
    </div>
  );
}

function Navbar({ t, lang, setLang }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <header style={{ position: 'fixed', inset: '0 0 auto 0', zIndex: 50, transition: 'all 0.5s', background: scrolled ? 'rgba(250,250,248,0.92)' : 'transparent', borderBottom: scrolled ? '1px solid var(--border)' : '1px solid transparent', backdropFilter: scrolled ? 'blur(20px)' : 'none' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 2rem', height: '72px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <a href="#top" style={{ textDecoration: 'none' }}>
          <img src="/logo.png" alt="Incorporate Pro" style={{ height: 'clamp(56px, 10vw, 80px)', width: 'auto' }} />
        </a>
        <nav className='desktop-nav' style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
          {t.navLinks.map(l => (
            <a key={l.href} href={l.href} style={{ fontSize: '13.5px', color: 'var(--text-muted)', textDecoration: 'none', transition: 'color .2s' }}
              onMouseEnter={e => e.target.style.color = 'var(--text)'}
              onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}>
              {l.label}
            </a>
          ))}
        </nav>
        <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem' }}>
          <a href="#contact" style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', background: 'var(--primary)', color: '#fff', padding: '9px 20px', borderRadius: '100px', fontSize: '13px', fontWeight: 500, textDecoration: 'none', transition: 'opacity .2s' }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
            {t.navCta} ↗
          </a>
        </div>
      </div>
    </header>
  );
}

function Hero({ t }) {
  return (
    <section id="top" style={{ paddingTop: '5rem', paddingBottom: '3rem', background: 'var(--bg)', position: 'relative', overflow: 'hidden' }}>
      <div aria-hidden="true" style={{ position: 'absolute', top: '-10rem', left: '50%', transform: 'translateX(-50%)', width: '900px', height: '520px', borderRadius: '50%', background: 'rgba(45,106,79,0.05)', filter: 'blur(80px)', pointerEvents: 'none' }} />
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 2rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '4rem', alignItems: 'center' }}>

        <div className="fade-up">


          <AvailabilityTracker />
          <h1 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(2.2rem, 4.5vw, 3.5rem)', fontWeight: 300, lineHeight: 1.1, letterSpacing: '-0.02em', color: 'var(--text)', marginBottom: '1.25rem' }}>
            {t.heroHeadline}
          </h1>

          <p style={{ fontFamily: 'var(--sans)', fontSize: '1.05rem', color: 'var(--text-sub)', lineHeight: 1.85, marginBottom: '2rem', maxWidth: '480px' }}>
            {t.heroSub}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '.85rem', marginBottom: '2.5rem', alignItems: 'flex-start' }}>
            <button onClick={() => { fireConversion(); window.open('https://wa.me/' + PHONE + '?text=' + encodeURIComponent('Send your free business launch roadmap'), '_blank'); }} style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'var(--primary)', color: '#fff', padding: '16px 32px', borderRadius: '100px', fontSize: '15px', fontWeight: 600, border: 'none', cursor: 'pointer', fontFamily: 'var(--sans)', transition: 'opacity .2s' }}
              onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              Get your free business roadmap
            </button>
            <a href="#contact" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', border: '1px solid var(--border)', color: 'var(--text-muted)', padding: '10px 22px', borderRadius: '100px', fontSize: '13px', textDecoration: 'none', background: 'transparent', transition: 'all .2s' }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--text)'; e.currentTarget.style.borderColor = 'var(--text)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.borderColor = 'var(--border)'; }}>
              {t.heroCta2}
            </a>
          </div>

          <ul style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem 2rem', listStyle: 'none', marginBottom: '1.5rem' }}>
            {t.heroBadges.map((b, i) => (
              <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '13px', color: 'var(--text)' }}>
                <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="var(--primary-light)" /><path d="M4.5 8L7 10.5L11.5 5.5" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" fill="none" /></svg>
                {b}
              </li>
            ))}
          </ul>
        </div>

        <div className="fade-up-2">
          <PackageCard t={t} hero />
        </div>
      </div>
      <style>{`@keyframes ping{75%,100%{transform:scale(2);opacity:0}}`}</style>
    </section>
  );
}

function StatsBar({ t }) {
  return (
    <section style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 2rem 6rem' }}>
      <Reveal>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', borderRadius: '20px', border: '1px solid var(--border)', background: 'var(--card)', overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.04)' }}>
          {t.stats.map((s, i) => (
            <div key={i} style={{ padding: '2.5rem 1.5rem', textAlign: 'center', borderRight: i < t.stats.length - 1 ? '1px solid var(--border)' : 'none' }}>
              <p style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(1.6rem,3vw,2.5rem)', fontWeight: 300, color: 'var(--primary)', letterSpacing: '-0.02em', lineHeight: 1 }}>{s.value}</p>
              <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '.6rem', lineHeight: 1.5 }}>{s.label}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}

function About({ t }) {
  return (
    <section id="about" style={{ borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)', background: 'rgba(45,106,79,0.02)', padding: '6rem 0' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '5rem', alignItems: 'start' }}>
          <div style={{ position: 'sticky', top: '7rem' }}>
            <Reveal>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem' }}>
                <span style={{ height: '1px', width: '32px', background: 'rgba(45,106,79,0.5)' }} />
                <span style={{ fontSize: '11px', fontWeight: 500, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--primary)' }}>{t.aboutEyebrow}</span>
              </div>
              <h2 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(1.8rem, 3vw, 2.6rem)', fontWeight: 300, color: 'var(--text)', lineHeight: 1.15, marginBottom: '1.5rem' }}>{t.aboutTitle}</h2>

              <div style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid var(--border)' }}>
                <img src="/riyadh.png" alt="Riyadh" style={{ width: '100%', objectFit: 'cover', display: 'block' }} />
              </div>
            </Reveal>
          </div>
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.75rem', marginBottom: '3rem' }}>
              {t.aboutBody.map((para, i) => (
                <Reveal key={i} delay={i * 70}>
                  <p style={{ fontFamily: 'var(--sans)', fontSize: '1.05rem', lineHeight: 2, color: i === 2 ? 'var(--text)' : 'var(--text-sub)', ...(i === 2 ? { background: 'var(--muted)', borderRadius: '12px', padding: '1.5rem', borderLeft: '3px solid var(--primary)' } : {}) }}>{para}</p>
                </Reveal>
              ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.25rem', marginBottom: '2.5rem' }}>
              {t.aboutReasons.map((r, i) => (
                <Reveal key={i} delay={i * 60}>
                  <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '14px', padding: '1.5rem' }}>
                    <h3 style={{ fontSize: '14px', fontWeight: 600, color: 'var(--text)', marginBottom: '.5rem' }}>{r.title}</h3>
                    <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: 1.7 }}>{r.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal>
              <p style={{ fontSize: '11px', fontWeight: 500, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: '1rem' }}>Fully compliant with</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {t.aboutAuthorities.map((a, i) => (
                  <span key={i} style={{ borderRadius: '100px', border: '1px solid var(--border)', background: 'var(--card)', padding: '5px 14px', fontSize: '12px', color: 'var(--text)' }}>{a}</span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}

function Packages({ t }) {
  return (
    <section id="packages" style={{ background: 'var(--muted)', padding: '6rem 0' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 2rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '1.25rem' }}>
            <span style={{ height: '1px', width: '32px', background: 'rgba(45,106,79,0.5)' }} />
            <span style={{ fontSize: '11px', fontWeight: 500, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--primary)' }}>{t.pkgEyebrow}</span>
            <span style={{ height: '1px', width: '32px', background: 'rgba(45,106,79,0.5)' }} />
          </div>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 300, color: 'var(--text)', marginBottom: '.6rem' }}>{t.pkgTitle}</h2>
          <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>{t.pkgDesc}</p>
        </div>
        <div style={{ maxWidth: '900px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
          <Reveal><PackageCard t={t} /></Reveal>
          <Reveal delay={90}>
            <div style={{ position: 'relative', borderRadius: '20px', border: '1.5px dashed var(--border2)', background: 'rgba(255,255,255,0.55)', padding: '2.5rem', display: 'flex', flexDirection: 'column' }}>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', fontWeight: 500, padding: '4px 12px', borderRadius: '100px', border: '1px solid var(--border)', background: 'var(--muted)', color: 'var(--text-muted)', marginBottom: '1.25rem', width: 'fit-content' }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                {t.pkg2Badge}
              </span>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.35rem', fontWeight: 400, color: 'var(--text)', marginBottom: '.35rem' }}>{t.pkg2Name}</h3>
              <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '1.75rem', lineHeight: 1.7 }}>{t.pkg2Desc}</p>
              <div style={{ marginBottom: '.35rem' }}><span style={{ fontFamily: 'var(--serif)', fontSize: '3rem', fontWeight: 300, color: 'var(--text-dim)', lineHeight: 1 }}>—</span></div>
              <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '2rem' }}>{t.pkg2PricingSoon}</p>
              <div style={{ flex: 1, borderRadius: '12px', border: '1px solid var(--border)', background: 'rgba(255,255,255,0.5)', padding: '1.25rem', marginBottom: '1.5rem' }}>
                <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: 1.8 }}>{t.pkg2WaitlistText}</p>
              </div>
              <WaitlistButton label={t.pkg2Cta} />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function TrackRecord({ t }) {
  const shots = ['/ss1.png', '/ss2.png', '/ss3.png'];
  return (
    <section id="track" style={{ maxWidth: '1280px', margin: '0 auto', padding: '6rem 2rem' }}>
      <Reveal>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem' }}>
          <span style={{ height: '1px', width: '32px', background: 'rgba(45,106,79,0.5)' }} />
          <span style={{ fontSize: '11px', fontWeight: 500, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--primary)' }}>Proof of Work</span>
        </div>
        <h2 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(1.8rem, 3vw, 2.6rem)', fontWeight: 300, color: 'var(--text)', marginBottom: '.75rem' }}>{t.trackTitle}</h2>
        <p style={{ fontSize: '14px', color: 'var(--text-muted)', marginBottom: '2.5rem', maxWidth: '560px', lineHeight: 1.8 }}>{t.trackDesc}</p>
      </Reveal>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
        {shots.map((src, i) => (
          <Reveal key={i} delay={i * 80}>
            <div style={{ borderRadius: '14px', overflow: 'hidden', border: '1px solid var(--border)', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', background: 'var(--card)' }}>
              <div style={{ background: '#F5F5F0', borderBottom: '1px solid var(--border)', padding: '.6rem 1rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#FFBDB5' }} />
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#FFE0A3' }} />
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#B5F0C8' }} />
                <span style={{ fontSize: '11px', color: 'var(--text-muted)', marginRight: 'auto', marginLeft: '8px' }}></span>
                <span style={{ fontSize: '10px', fontWeight: 600, padding: '2px 8px', borderRadius: '100px', background: '#D1FAE5', color: '#065F46' }}>Completed</span>
              </div>
              <img src={src} alt={`Completed formation ${i + 1}`} style={{ width: '100%', display: 'block', objectFit: 'cover' }} />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

function FaqItem({ q, a, index }) {
  const [open, setOpen] = useState(index === 0);
  return (
    <Reveal>
      <div style={{ borderBottom: '1px solid var(--border)' }}>
        <button onClick={() => setOpen(v => !v)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '2rem', padding: '1.5rem 0', textAlign: 'left', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
          <span style={{ fontSize: '1.05rem', fontWeight: 500, color: 'var(--text)', lineHeight: 1.5 }}>{q}</span>
          <span style={{ color: 'var(--primary)', fontSize: '1.4rem', lineHeight: 1, flexShrink: 0, transform: open ? 'rotate(45deg)' : 'none', transition: 'transform .3s ease' }}>+</span>
        </button>
        <div style={{ display: 'grid', gridTemplateRows: open ? '1fr' : '0fr', opacity: open ? 1 : 0, transition: 'grid-template-rows .3s ease, opacity .25s ease', paddingBottom: open ? '1.5rem' : 0 }}>
          <div style={{ overflow: 'hidden' }}>
            <p style={{ fontSize: '14px', color: 'var(--text-sub)', lineHeight: 1.9, maxWidth: '680px' }}>{a}</p>
          </div>
        </div>
      </div>
    </Reveal>
  );
}

function FAQ({ t }) {
  return (
    <section id="faq" style={{ maxWidth: '780px', margin: '0 auto', padding: '0 2rem 7rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '1rem' }}>
          <span style={{ height: '1px', width: '32px', background: 'rgba(45,106,79,0.5)' }} />
          <span style={{ fontSize: '11px', fontWeight: 500, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--primary)' }}>{t.faqEyebrow}</span>
          <span style={{ height: '1px', width: '32px', background: 'rgba(45,106,79,0.5)' }} />
        </div>
        <h2 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(1.8rem, 3.5vw, 2.6rem)', fontWeight: 300, color: 'var(--text)' }}>{t.faqTitle}</h2>
      </div>
      <div>{t.faqs.map((faq, i) => <FaqItem key={i} q={faq.q} a={faq.a} index={i} />)}</div>
    </section>
  );
}

function Field({ label, name, type = 'text', placeholder, required }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <label style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text)' }}>{label}</label>
      <input name={name} type={type} required={required} placeholder={placeholder} style={{ height: '42px', borderRadius: '10px', border: '1px solid var(--border)', background: 'var(--bg)', padding: '0 14px', fontSize: '13px', color: 'var(--text)', outline: 'none', fontFamily: 'var(--sans)', transition: 'border-color .2s' }}
        onFocus={e => e.target.style.borderColor = 'var(--primary)'}
        onBlur={e => e.target.style.borderColor = 'var(--border)'} />
    </div>
  );
}

function Contact({ t }) {
  const [submitted, setSubmitted] = useState(false);
  return (
    <section id="contact" style={{ borderTop: '1px solid var(--border)', background: 'var(--muted)', padding: '6rem 0' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '5rem', alignItems: 'start' }}>
          <Reveal>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem' }}>
              <span style={{ height: '1px', width: '32px', background: 'rgba(45,106,79,0.5)' }} />
              <span style={{ fontSize: '11px', fontWeight: 500, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--primary)' }}>{t.conEyebrow}</span>
            </div>
            <h2 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 300, color: 'var(--text)', lineHeight: 1.1, marginBottom: '1rem' }}>{t.conTitle}</h2>
            <p style={{ fontFamily: 'var(--sans)', fontSize: '1.05rem', color: 'var(--text-sub)', lineHeight: 1.85 }}>{t.conSub}</p>
            <div style={{ marginTop: '2.5rem', borderRadius: '16px', overflow: 'hidden', border: '1px solid var(--border)' }}>
              <img src="/consultation.png" alt="Consultation" style={{ width: '100%', objectFit: 'cover', display: 'block' }} />
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div style={{ borderRadius: '20px', border: '1px solid var(--border)', background: 'var(--card)', padding: '2.5rem', boxShadow: '0 4px 24px rgba(0,0,0,0.04)' }}>
              {submitted ? (
                <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
                  <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'var(--primary-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem', color: 'var(--primary)' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  </div>
                  <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.5rem', fontWeight: 300, color: 'var(--text)', marginBottom: '.5rem' }}>{t.formSuccess}</h3>
                </div>
              ) : (
                <form onSubmit={async e => { e.preventDefault(); const fd = new FormData(e.target); try { await fetch('https://formspree.io/f/xqerwzky', { method: 'POST', headers: {'Accept': 'application/json'}, body: fd }); } catch(err) { console.log(err); } fireConversion(); setSubmitted(true); }} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                    <Field label={t.formName} name="name" placeholder={t.formNamePh} required />
                    <Field label={t.formEmail} name="email" type="email" placeholder={t.formEmailPh} required />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                    <Field label={t.formPhone} name="phone" type="tel" placeholder={t.formPhonePh} required />
                    <Field label={t.formCompany} name="company" placeholder={t.formCompanyPh} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <label style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text)' }}>{t.formMessage}</label>
                    <textarea name="message" required rows={4} placeholder={t.formMessagePh} style={{ borderRadius: '10px', border: '1px solid var(--border)', background: 'var(--bg)', padding: '10px 14px', fontSize: '13px', color: 'var(--text)', outline: 'none', resize: 'vertical', fontFamily: 'var(--sans)', transition: 'border-color .2s' }}
                      onFocus={e => e.target.style.borderColor = 'var(--primary)'}
                      onBlur={e => e.target.style.borderColor = 'var(--border)'} />
                  </div>
                  <button type="submit" style={{ width: '100%', padding: '14px', borderRadius: '100px', fontSize: '13.5px', fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)', background: 'var(--primary)', color: '#fff', border: 'none', transition: 'opacity .2s' }}
                    onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
                    onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                    onClick={() => fireConversion()}>
                    {t.formSubmit} ↗
                  </button>
                  <p style={{ fontSize: '11px', color: 'var(--text-dim)', textAlign: 'center' }}>Your information is kept strictly confidential.</p>
                </form>
              )}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function Footer({ t }) {
  return (
    <footer style={{ borderTop: '1px solid var(--border)', background: 'var(--bg)' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '4rem 2rem 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '3rem', marginBottom: '3rem' }}>
          <div style={{ gridColumn: 'span 2' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1rem' }}>
              <img src="/logo.png" alt="Incorporate Pro" style={{ height: '100px', width: 'auto' }} />
            </div>
            <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: 1.8, maxWidth: '280px' }}>{t.footerDesc}</p>
          </div>
          <div>
            <h3 style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text)', marginBottom: '1rem' }}>{t.footerServices}</h3>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '.75rem' }}>
              {t.footerServicesLinks.map((l, i) => (
                <li key={i}><a href="#packages" style={{ fontSize: '13px', color: 'var(--text-muted)', textDecoration: 'none', transition: 'color .2s' }}
                  onMouseEnter={e => e.target.style.color = 'var(--text)'}
                  onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}>{l}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h3 style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text)', marginBottom: '1rem' }}>{t.footerContact}</h3>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '.75rem' }}>
              <li><a href={`mailto:${t.footerEmail}`} style={{ fontSize: '13px', color: 'var(--text-muted)', textDecoration: 'none', transition: 'color .2s' }}
                onMouseEnter={e => e.target.style.color = 'var(--text)'}
                onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}>{t.footerEmail}</a></li>
              <li><a href={`tel:${t.footerPhone}`} style={{ fontSize: '13px', color: 'var(--text-muted)', textDecoration: 'none', direction: 'ltr', display: 'inline-block', transition: 'color .2s' }}
                onMouseEnter={e => e.target.style.color = 'var(--text)'}
                onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}>{t.footerPhone}</a></li>
            </ul>
          </div>
        </div>
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '.75rem' }}>
          <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{t.footerCopy}</p>
          <p style={{ fontSize: '11px', color: 'var(--text-dim)', marginTop: '.75rem', maxWidth: '700px', lineHeight: 1.7 }}>IncorporatePRO is an independent business consultancy. We are not a government entity and do not issue government documents; we guide and represent clients through the official government process.</p>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <a href="#" style={{ fontSize: '12px', color: 'var(--text-muted)', textDecoration: 'none' }}>{t.footerPrivacy}</a>
            <a href="#" style={{ fontSize: '12px', color: 'var(--text-muted)', textDecoration: 'none' }}>{t.footerTerms}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function App() {
  const t = ar;

  useEffect(() => {
    document.documentElement.dir = 'ltr';
    document.documentElement.lang = 'en';
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)', direction: 'ltr' }}>
      <Navbar t={t} lang="en" setLang={() => {}} />
      <main>
        <Hero t={t} />
        <StatsBar t={t} />
        <About t={t} />
        <Packages t={t} />
        <TrackRecord t={t} />
        <FAQ t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}
